import React from 'react'
import './Alumni.css'

function Alumni() {
  return (
    <div className='alumni'>
      <div className='section__container'>
        <div className='section'>
            <h1 className='section__header'>Alumni</h1>
            <p className='about__p'>MEC is not only famous for its highly experienced faculty and quality of education but also boasts about their strong alumni network, popularly called as xMECians. The list of renowned and eminent xMECians keeps on getting lengthier as every other year MEC produces prominent students that go on to make a strong impact in their respective fields
            </p>
        </div>
      </div>
    </div>
  )
}

export default Alumni